import { feedbackQuotes } from "@/mocks/homeContent";

export default function Feedback() {
  return (
    <section id="feedback" className="w-full border-b border-background-200 bg-accent-50">
      <div className="w-full px-4 py-12 md:px-8 md:py-20">
        <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <div>
            <p className="font-label text-[11px] uppercase tracking-[0.34em] text-accent-700">Voices · 读者原话</p>
            <h2 className="mt-4 font-heading text-3xl font-bold text-foreground-950 md:text-4xl">
              别人是怎么解决这些问题的
            </h2>
          </div>
          <p className="max-w-md text-sm leading-relaxed text-foreground-600">
            没有总结，只有原话。同一件事，不同人踩到的坑并不一样。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-5 md:grid-cols-3">
          {feedbackQuotes.map((q) => (
            <blockquote
              key={q.meta}
              className="flex flex-col justify-between rounded-lg border border-accent-200 bg-background-50 p-6 md:p-7"
            >
              <p className="font-heading text-base leading-relaxed text-foreground-800">“{q.text}”</p>
              <footer className="mt-6 flex items-center gap-3 border-t border-background-200 pt-5">
                <span className="flex h-7 w-7 items-center justify-center rounded-full bg-accent-100 text-accent-700">
                  <i className="ri-chat-quote-line text-sm" />
                </span>
                <span className="text-xs text-foreground-500">{q.meta}</span>
              </footer>
            </blockquote>
          ))}
        </div>

        <div className="mt-10 flex flex-col items-start gap-4 rounded-lg border border-accent-200 bg-background-50 p-6 sm:flex-row sm:items-center sm:justify-between md:p-8">
          <div>
            <h3 className="font-heading text-lg font-semibold text-foreground-950">你的经历，也值得被记下</h3>
            <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">
              遇到打不开、审核慢、验证多还是广告烦，都可以把过程说出来，帮下一个人少走一步。
            </p>
          </div>
          <div className="flex shrink-0 flex-col gap-3 sm:flex-row">
            <a
              href="#faq"
              className="cursor-pointer whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-center text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
            >
              我要说说我的经历
            </a>
            <a
              href="#index"
              className="cursor-pointer whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-6 py-3 text-center text-sm font-semibold text-foreground-800 transition-colors hover:border-foreground-400"
            >
              回到问题索引
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}